import { ReactNode } from "react";
import { datetime } from "../../util/library/datetime";
import { IOperation } from "../../util/varibles/interface";
import { createFastContext } from "../createFastContext";

interface IState {
    startTime: number
    finishTime: number
    operations: { [id: string]: IOperation & { site_ids?: string[] } }
    loading: boolean
    loadingMode: "left" | "right" | "center",
    before: boolean
    after: boolean
    minHeight: number
    widthDay: number
}

const {
    Provider,
    useStore: useCalendar,
    setStore: setCalendar,
    getStore: getCalendar,
    callEvent: callEventCalendar
} = createFastContext<IState, {
}>({
    startTime: datetime().startOf('week').subtract(6, 'week').time,
    finishTime: datetime().endOf('week').add(6, 'week').time,
    operations: {},
    loading: false,
    loadingMode: "center",
    before: false,
    after: false,
    minHeight: 120,
    widthDay: 90
});

const CalendarProvider = ({ children, ...args }: {
    children: ReactNode,
} & Partial<IState>) => {
    return <Provider props={{ ...args }}>
        {children}
    </Provider>
}


export { CalendarProvider, callEventCalendar, getCalendar, setCalendar, useCalendar };

